<template>
<div class="pr-3 pl-3 inner-admin-container">
  <b-form v-on:submit.prevent="save">
    <b-row>
      <b-col>
        <b-form-group id="name-group" horizontal label-size="sm" label="Name:" label-for="name-input">
          <b-form-input id="name-input" size="sm" type="text" v-model="workpack.name" v-on:keyup.native="commitValue('name')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="case_type-group" horizontal label-size="sm" label="Case Type:" label-for="case_type-input">
          <b-form-input id="case_type-input" size="sm" type="text" v-model="workpack.case_type" v-on:keyup.native="commitValue('case_type')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="name_abbrev-group" horizontal label-size="sm" label="Name Abbreviation:" label-for="name_abbrev-input">
          <b-form-input id="name_abbrev-input" size="sm" type="text" v-model="workpack.name_abbrev" v-on:keyup.native="commitValue('name_abbrev')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="waterforecast_tablename-group" horizontal label-size="sm" label="Water Forecast Table Name:" label-for="waterforecast_tablename-input">
          <b-form-select id="waterforecast_tablename-input" size="sm" type="text" @change="setForecastTable('waterforecast_tablename', $event)" v-model="selected_water" :options="water_options" placeholder="None">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="gasforecast_tablename-group" horizontal label-size="sm" label="Gas Forecast Table Name:" label-for="gasforecast_tablename-input">
          <b-form-select id="gasforecast_tablename-input" size="sm" type="text" @change="setForecastTable('gasforecast_tablename', $event)" v-model="selected_gas" :options="gas_options" placeholder="None">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="gasforecast_tablename-group" horizontal label-size="sm" label="Online Date Table Name:" label-for="online_date_tablename-input">
          <b-form-select id="online_date_tablename-input" size="sm" type="text" @change="setForecastTable('online_date_tablename', $event)" v-model="selected_online" :options="online_options" placeholder="None">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="best_srid-group" horizontal label-size="sm" label="Best SRID:" label-for="best_srid-input">
          <b-form-input id="best_srid-input" size="sm" type="text" v-model="workpack.best_srid" v-on:keyup.native="commitValue('best_srid')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="redmine_issue_id-group" horizontal label-size="sm" label="Redmine Issue ID:" label-for="redmine_issue_id-input">
          <b-form-input id="redmine_issue_id-input" size="sm" type="number" v-model="workpack.redmine_issue_id" v-on:keyup.native="commitValue('redmine_issue_id')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="redmine_project_id-group" horizontal label-size="sm" label="Redmine Project ID:" label-for="redmine_project_id-input">
          <b-form-input id="redmine_project_id-input" size="sm" type="number" v-model="workpack.redmine_project_id" v-on:keyup.native="commitValue('redmine_project_id')" placeholder="None">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button type="submit" class="btn-xs" variant="primary" v-on:submit.prevent="save">Save</b-button>
  </b-form>
</div>
</template>
<script>
export default {
  data() {
    return {
      workpack: {},
      package: {},
      gas_options: [],
      water_options: [],
      online_options: [],
      selected_water: '',
      selected_gas: '',
      selected_online: ''
    }
  },
  props: {
    tabIndex: {
      default: 0
    }
  },
  mounted() {
    this.getWorkpackSettings()
  },
  methods: {
    getWorkpackSettings() {
      this.$http.get('/api/admin-board/workpack-settings', {
        params: {
          id: this.$store.getters['project/currentProject'].workpack.id
        }
      })
        .then(res => {
          this.workpack = res.body.workpack[0]
          this.water_options = []
          this.gas_options = []
          this.online_options = []
          
          res.body.water.forEach( (g, i) => {
            this.water_options.push({
              text: g.table_name,
              value: g.table_name
            })
          })

          res.body.gas.forEach( (g, i) => {
            this.gas_options.push({
              text: g.table_name,
              value: g.table_name
            })
          })

          res.body.online.forEach( (g, i) => {
            this.online_options.push({
              text: g.table_name,
              value: g.table_name
            })
          })

          this.selected_water = this.workpack.waterforecast_tablename
          this.selected_gas = this.workpack.gasforecast_tablename
          this.selected_online = this.workpack.online_date_tablename

        }, r => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not get current workpack settings',
            type: 'error'
          })
        })
    },
    setForecastTable(key, event) {
      if (event) {
        this.package[key] = event
      }
    },
    commitValue(key) {
      this.package[key] = this.workpack[key]
    },
    save() {
      if (Object.keys(this.package).length > 0) {
        this.$http.post('/api/admin-board/update-workpack/', {
          id: this.workpack['id'],
          data: this.package
        }).then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Workpack settings updated',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not update workpack',
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'No changes to save',
          type: 'error'
        })
      }
    }
  },
  watch: {
    tabIndex (val) {
      if (val === 0) {
        this.getWorkpackSettings()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/WorkpackSettings.vue